import * as React from 'react';
import {PopoverConfig} from './PopoverConfig';
import {PopoverBottomSheet} from './Popover.bottomsheet';
import {DesktopPopover} from './Popover.desktop';
import {useShouldDisplayBottomSheet} from '../bottom-sheet/useShouldDisplayBottomSheet';

export const Popover = PopoverConfig.createView((props) => {
  const shouldDisplayBottomSheet = useShouldDisplayBottomSheet();

  return shouldDisplayBottomSheet ? (
    <PopoverBottomSheet {...props} />
  ) : (
    <DesktopPopover {...props} />
  );
});
